export const PrefixedId = prefix => {
  const is = id => id.startsWith(prefix);
  const create = id => {
    if (is(id)) {
      return id;
    }
    return `${prefix}${id}`;
  };
  const strip = id => {
    if (!is(id)) {
      return id;
    }
    return id.slice(prefix.length);
  };
  return Object.assign(create, {
    is,
    strip,
    create
  });
};